import { Modal, styled } from "@mui/material";
import { IStyledModalProps } from "./types";

const StyledModal = styled(Modal)<IStyledModalProps>(({ theme }) => ({
    "& .MuiPaper-root": {
        padding: theme.spacing(2),
        borderRadius: (theme as any).shape.border.general.radius[9],
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: 'translate(-50%, -50%)',
        width: "800px",
        backgroundColor: (theme as any).palette.neutral.darkest,
        p: theme.spacing(2),
    }
}))

export { StyledModal }